import { cva } from 'class-variance-authority'

export const pillStyles = cva(
  `
    inline-flex
    items-center
    rounded-full
    font-semibold
  `,
  {
    variants: {
      variant: {
        default: '',
        secondary: '',
        outline: 'border',
        dashed:
          'border border-dashed border-neutral-400 bg-transparent text-neutral-700',
      },
      size: {
        sm: 'px-2 py-0.5 text-xs',
        md: 'px-3 py-1 text-xs',
      },
      color: {
        green: '',
        olive: '',
        orange: '',
        red: '',
        yellow: '',
        purple: '',
        blue: '',
        pink: '',
        gray: '',
        white: '',
      },
      uppercase: {
        true: 'uppercase tracking-wide',
        false: 'leading-[1.2]',
      },
    },
    compoundVariants: [
      // default
      {
        variant: 'default',
        color: 'green',
        class: 'bg-green-100 text-neutral-0',
      },
      { variant: 'default', color: 'olive', class: 'bg-moss-50 text-moss-300' },
      {
        variant: 'default',
        color: 'orange',
        class: 'bg-orange-200 text-neutral-0',
      },
      { variant: 'default', color: 'red', class: 'bg-red-100 text-neutral-0' },
      {
        variant: 'default',
        color: 'yellow',
        class: 'bg-yellow-200 text-neutral-900',
      },
      {
        variant: 'default',
        color: 'purple',
        class: 'bg-purple-100 text-neutral-0',
      },
      {
        variant: 'default',
        color: 'blue',
        class: 'bg-blue-100 text-neutral-0',
      },
      {
        variant: 'default',
        color: 'pink',
        class: 'bg-pink-100 text-neutral-0',
      },
      {
        variant: 'default',
        color: 'gray',
        class: 'bg-neutral-200 text-neutral-700',
      },
      {
        variant: 'default',
        color: 'white',
        class: 'bg-neutral-0 text-neutral-600 border border-neutral-200',
      },
      // secondary
      {
        variant: 'secondary',
        color: 'green',
        class: 'bg-green-25 text-green-200',
      },
      {
        variant: 'secondary',
        color: 'olive',
        class: 'bg-moss-25 text-moss-200',
      },
      {
        variant: 'secondary',
        color: 'orange',
        class: 'bg-orange-25 text-orange-200',
      },
      { variant: 'secondary', color: 'red', class: 'bg-red-25 text-red-200' },
      {
        variant: 'secondary',
        color: 'yellow',
        class: 'bg-yellow-25 text-yellow-200',
      },
      {
        variant: 'secondary',
        color: 'purple',
        class: 'bg-purple-25 text-purple-200',
      },
      {
        variant: 'secondary',
        color: 'blue',
        class: 'bg-blue-25 text-blue-200',
      },
      {
        variant: 'secondary',
        color: 'pink',
        class: 'bg-pink-25 text-pink-200',
      },
      {
        variant: 'secondary',
        color: 'gray',
        class: 'bg-neutral-100 text-neutral-800',
      },
      {
        variant: 'secondary',
        color: 'white',
        class: 'bg-neutral-0 text-neutral-600 border border-neutral-200',
      },
      {
        variant: 'outline',
        color: 'green',
        class: 'bg-green-25 border-green-100 text-green-100',
      },
    ],
    defaultVariants: {
      size: 'md',
      color: 'olive',
      variant: 'default',
      uppercase: true,
    },
  }
)
